import fancy_serializer from './object/trex_fancy_serializer'

export const concat_url = (first: string, second: string) => (
	(first.endsWith(`/`) ? first.slice(0, -1) : first)
	+ `/`
	+ (second.startsWith(`/`) ? second.slice(1) : second)
)

export type FetchyOptions = Omit<RequestInit, `body`> & {
	body?: object | string
	fancily_serialize_body?: boolean
	expect_fancily_serialized_response?: boolean
}

class FetchyError extends Error {
	statusMessage: string
	statusCode: number
	status_code: number
	headers: Headers
	data: any
	request_uri: string
	request_body: object | string | undefined
	errors?: {
		message: string
	}[]

	constructor(response: Response, method: string = `GET`, uri: string, body: object | string | undefined, data: any) {
		super(`Server responded with ${ response.status } (${ method } ${ uri })`)

		this.statusMessage = response.statusText
		this.statusCode = response.status
		this.status_code = response.status
		this.headers = response.headers
		this.data = data
		this.request_uri = uri
		this.request_body = body

		if (typeof data === `string`) {
			this.errors = [{ message: data }]
		} else if (data && typeof data === `object`) {
			Object.assign(this, data)
		}
	}
}

export default (api_prefix: string) => async(path: string, options: FetchyOptions = {}): Promise<any> => {
	const {
		body,
		fancily_serialize_body = false,
		expect_fancily_serialized_response = false,
		...rest
	} = options

	const request_options: RequestInit = rest

	if (body !== undefined && body !== null) {
		if (fancily_serialize_body) {
			request_options.headers = {
				...request_options.headers,
				'content-type': `application/x.trex-fancy+json;charset=utf-8`,
			}
			request_options.body = fancy_serializer.serialize(body)
		} else if (typeof body === `object`) {
			request_options.headers = {
				...request_options.headers,
				'content-type': `application/json`,
			}
			request_options.body = JSON.stringify(body)
		} else {
			request_options.body = body.toString()
		}
	}

	if (expect_fancily_serialized_response) {
		request_options.headers = {
			...request_options.headers,
			accept: `application/x.trex-fancy+json;charset=utf-8`,
		}
	}

	const response = await fetch(concat_url(api_prefix, path), request_options)

	let data

	if (response.headers.get(`content-type`)?.startsWith(`application/json`)) {
		data = await response.json()
	} else if (response.headers.get(`content-type`)?.startsWith(`application/x.trex-fancy+json`)) {
		data = fancy_serializer.deserialize(await response.text())
	} else {
		data = await response.text()
	}

	if (!response.ok) {
		throw new FetchyError(response, request_options.method, path, body, data)
	}

	return data
}
